import React from "react";
import {FormattedMessage} from "react-intl";

export default (props) => {
  return (
    <h1 className="page-title">
      <FormattedMessage id="cookie.title" defaultMessage="Cookie policy"/>
    </h1>
  );
}
